/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from "react";
import { RoleGate } from "./components/role-gate";
import { Loading } from "./components/ui/loading";
import { ROLE } from "./utils/constant";
import { keycloak } from "./utils/lib/keycloak";

// Permit Issue Module
const PermitIssue = lazy(() => import("e2e/PermitIssue"));
const PermitIssueDetail = lazy(() => import("e2e/PermitIssueDetail"));

// Permit Reimbursement Module
const PermitReimbursement = lazy(() => import("e2e/PermitReimburse"));
const PermitReimbursementDetail = lazy(
  () => import("e2e/PermitReimburseDetail"),
);
const PermitReimburseCreate = lazy(() => import("e2e/PermitReimburseCreate"));

export const e2eSplitRoutes = [
  {
    path: "permit-issue",
    children: [
      {
        path: "permit-issue-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.PERMIT_DISPATCH,
                    ROLE.PERMIT_MONITORING,
                    ROLE.PROJECT_OPERATIONAL_LEAD,
                    ROLE.PROJECT_MANAGER,
                    ROLE.PERMIT_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitIssue keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.PERMIT_DISPATCH,
                    ROLE.PERMIT_MONITORING,
                    ROLE.PROJECT_OPERATIONAL_LEAD,
                    ROLE.PROJECT_MANAGER,
                    ROLE.PERMIT_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitIssueDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "permit-reimbursement",
    children: [
      {
        path: "permit-reimbursement-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.PERMIT_MONITORING,
                    ROLE.PERMIT_DISPATCH,
                    ROLE.PROJECT_OPERATIONAL_LEAD,
                    ROLE.PROJECT_MANAGER,
                    ROLE.PBO,
                    ROLE.PERMIT_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitReimbursement keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.PERMIT_MONITORING,
                    ROLE.PERMIT_DISPATCH,
                    ROLE.PROJECT_OPERATIONAL_LEAD,
                    ROLE.PROJECT_MANAGER,
                    ROLE.PBO,
                    ROLE.PERMIT_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitReimbursementDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: "create-permit-reimbursement",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate roles={[ROLE.VENDOR]}>
                  <PermitReimburseCreate keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];
